import { motion } from "framer-motion";
import { ClipboardCheck, DoorOpen, Trophy, Award } from "lucide-react";

const steps = [
  { icon: ClipboardCheck, title: "التسجيل الإلكتروني", desc: "املأ بيانات طفلك واختَر الأنشطة في دقيقتين فقط.", color: "#0066CC" },
  { icon: DoorOpen, title: "دخول المهرجان", desc: "استقبال حار في 17 سبتمبر واكتشاف كل الفعاليات.", color: "#FFD600" },
  { icon: Trophy, title: "الإبداع والمنافسة", desc: "شارك بالورش والمسابقات وتألّق مع أصدقائك.", color: "#E63946" },
  { icon: Award, title: "التتويج والشهادات", desc: "شهادة حضور وجوائز لنجوم المهرجان الصغار.", color: "#10B981" },
];

export default function Journey() {
  return (
    <section id="journey" className="relative py-24 sm:py-32 bg-white" data-testid="journey-section">
      <div className="container-x">
        <div className="mb-14 max-w-2xl">
          <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-[#0066CC]/10 text-[#0066CC] text-xs font-black mb-3">
            رحلة طفلك
          </div>
          <h2 className="font-display text-3xl sm:text-5xl font-black text-[#1E293B]" data-testid="journey-title">
            كيف يبدأ المرح؟
          </h2>
          <p className="mt-3 text-[#475569] font-semibold">أربع خطوات بسيطة تفصلك عن مغامرة لن ينساها طفلك.</p>
        </div>

        <div className="relative grid md:grid-cols-4 gap-6">
          {/* Connecting line */}
          <div className="hidden md:block absolute top-9 right-8 left-8 h-1 bg-gradient-to-l from-[#0066CC] via-[#FFD600] to-[#10B981] rounded-full opacity-30" />

          {steps.map((s, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: i * 0.1 }}
              className="relative playful-card text-right"
              data-testid={`journey-step-${i + 1}`}
            >
              <div className="flex items-center justify-between mb-4">
                <span className="font-display text-4xl font-black text-[#E2E8F0]">
                  {String(i + 1).padStart(2, "0")}
                </span>
                <div
                  className="w-14 h-14 rounded-2xl flex items-center justify-center text-white shadow-lg"
                  style={{ backgroundColor: s.color }}
                >
                  <s.icon className="w-7 h-7" />
                </div>
              </div>
              <h3 className="font-display text-lg font-black text-[#1E293B]">{s.title}</h3>
              <p className="text-sm text-[#475569] mt-1 font-medium">{s.desc}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
